import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/transition-360/projects/$projectId/assets/$projectAssetId/',
)({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/transition-360/projects/$projectId/assets/$projectAssetId/repository',
            params,
        });
    },
});
